import axios from 'axios';

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('w8_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401 && window.location.pathname.startsWith('/admin') && window.location.pathname !== '/admin/login') {
      localStorage.removeItem('w8_token');
      localStorage.removeItem('w8_user');
      window.location.href = '/admin/login';
    }
    return Promise.reject(err);
  }
);

export const getUser = () => {
  try {
    return JSON.parse(localStorage.getItem('w8_user') || 'null');
  } catch {
    return null;
  }
};

export const setAuth = (token, user) => {
  localStorage.setItem('w8_token', token);
  localStorage.setItem('w8_user', JSON.stringify(user));
};

export const logout = () => {
  localStorage.removeItem('w8_token');
  localStorage.removeItem('w8_user');
  window.location.href = '/admin/login';
};

// Resolve uploaded file URLs (stored as /api/uploads/...) to full backend URL
export const fileUrl = (url) => {
  if (!url) return '';
  if (url.startsWith('http') || url.startsWith('data:')) return url;
  return `${BACKEND_URL}${url}`;
};

export const uploadFile = async (file, category = 'general') => {
  const form = new FormData();
  form.append('file', file);
  form.append('category', category);
  const res = await api.post('/upload', form, { headers: { 'Content-Type': 'multipart/form-data' } });
  return res.data;
};

export const publicUploadImage = async (file) => {
  const form = new FormData();
  form.append('file', file);
  const res = await axios.post(`${API}/public-upload`, form, { headers: { 'Content-Type': 'multipart/form-data' } });
  return res.data;
};
